var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"white--text copyright pa-0"},[_c('v-layout',[_c('div',[_vm._v(" Zoologická zahrada hl. m. Prahy, U Trojského zámku 120/3, 171 00 Praha 7 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }